import React, { createContext, useContext, type ReactNode } from 'react';
import { useConfiguration } from '../hooks/use-configuration';
import { Configuration } from '../../api/api-client';
import { Spinner } from '@@/ui/components';

const ConfigurationContext = createContext<Configuration | undefined>(undefined);

export const ConfigurationProvider = ({ children }: { children: ReactNode }) => {
  const configurationData = useConfiguration();

  if (!configurationData.data) {
    return (
      <div className='flex justify-center items-center h-full py-12 gap-2'>
        <Spinner size='sm' />
        <span className='text-sm'>Loading configuration...</span>
      </div>
    );
  }

  return (
    <ConfigurationContext.Provider value={configurationData.data.config}>{children}</ConfigurationContext.Provider>
  );
};

export const useConfigurationContext = () => {
  const context = useContext(ConfigurationContext);
  if (context === undefined) {
    throw new Error('useConfigurationContext must be used within a ConfigurationProvider');
  }
  return context;
};
